"use strict";

exports.__esModule = true;
exports.SessionLive = void 0;
var _Constant = require("../Utils/Constant");
var _DashManifestParser = require("../Parsers/DashManifestParser");
var _DefaultPlaybackPolicyHandler = require("../internal/DefaultPlaybackPolicyHandler");
var _Event = require("../internal/Event");
var _Session2 = require("./Session");
var _YoLog = require("../Utils/YoLog");
var _StringUtils = require("../Utils/StringUtils");
var _ReportsManager = require("../Core/ReportsManager");
var _HlsManifestParser = require("../Parsers/HlsManifestParser");
var _TimedMetadata = require("./TimedMetadata");
var _HttpConnection = require("../Utils/HttpConnection");
var _HttpUtils = require("../Utils/HttpUtils");
var _UrlPoller = require("../internal/UrlPoller");
var _Parser = require("../Parsers/Parser");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var AdvertStatus = Object.freeze({
  PLAYED_OUT: 0,
  NOT_PLAYED_OUT: 1,
  NEW_ADVERT_STARTING: 2
});

/**
 * Concrete Session implementation representing a single viewing of a single live stream sourced from
 * the Yospace Video Platform via the Central Streaming Manager (CSM)
 * @see {@link Session} base class
 * @hideconstructor
 */
var SessionLive = /*#__PURE__*/function (_Session) {
  _inheritsLoose(SessionLive, _Session);
  /**
   * 
   * @param {SessionProperties} properties the properties for the Session
   * @param {string} analyticUrl 
   * @param {string} playerUrl 
   */
  function SessionLive(properties, analyticUrl, playerUrl) {
    var _this;
    _this = _Session.call(this, properties) || this;

    /** @private */
    _this.advertEndWatchdog = null;
    /** @private */
    _this.interSegmentTimeout = _Constant.Constant.INTERSEGMENT_TIMEOUT;
    /** @private */
    _this.lastTimedMetadata = null;
    /** @private */
    _this.pendingTimedMetadata = null;
    /** @private */
    _this.historicalTimedMetadata = [];
    /** @private */
    _this.inAdBreak = false;
    /** @private */
    _this.targetDuration = _Constant.Constant.DEFAULT_POLLING_DELAY;
    _this.setAnalyticsUrl(analyticUrl);
    _this.setPlaybackUrl(playerUrl);
    _this.setPlaybackPolicyHandler(new _DefaultPlaybackPolicyHandler.DefaultPlaybackPolicyHandler(_Session2.PlaybackMode.LIVE));
    return _this;
  }

  /**
   * @callback sessionCallback 
   * @param {SessionLive} session a completed session object
   */

  /**
   * The factory method for creating a SessionLive instance, when using Direct Initialisation.
   * Constructs and initialises a new SessionLive using the {@link SessionProperties} provided.
   * On completion calls the EventListener provided passing the initialised SessionLive back if 
   * a callback was provided.  If a callback was not provided, a Promise is returned instead.
   *
   * @param {string} url The Yospace initialisation URL to the Central Streaming Manager
   * @param {SessionProperties} [properties] (Optional) An initialisation properties object
   * @param {sessionCallback} [callback] (Optional) A completion handler to call after initialisation is finished.
   */
  SessionLive.create = function create(url, properties, callback) {
    var session = new SessionLive(properties);
    if (callback) {
      session.initialiseFromSession(url).then(function () {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Session initialised");
      })["catch"](function () {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Session failed to initialise");
      })["finally"](function () {
        callback(new _Event.Event(session));
      });
    } else {
      return session.initialiseFromSession(url);
    }
  };
  var _proto = SessionLive.prototype;
  _proto.cancelScheduleWatchdog = function cancelScheduleWatchdog() {
    if (this.advertEndWatchdog !== null) {
      clearTimeout(this.advertEndWatchdog);
      this.advertEndWatchdog = null;
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Cancelled watchdog timer");
    }
  };
  _proto.getAdBreakForAdvert = function getAdBreakForAdvert(advert) {
    if (advert && this.linearAdBreaks.length > 0) {
      var mediaId = advert.getMediaIdentifier();
      for (var _iterator = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step; !(_step = _iterator()).done;) {
        var ab = _step.value;
        var ad = ab.getAdvertFromIdentifier(mediaId);
        if (ad) {
          return ab;
        }
      }
    }
    return null;
  }

  // Returns the first active Advert with the Yospace id provided.
  // Removes any breaks prior to the one in which the advert is found.
  // Sets any perceived 'orphaned' adverts inactive prior to this one in the break.
  ;
  _proto.getFirstAdvertRemovingAllPrevious = function getFirstAdvertRemovingAllPrevious(mediaId) {
    if (this.linearAdBreaks.length === 0) {
      return null;
    }
    var match = null;
    var breakIndexFound = -1;
    for (var breakIndex = 0; breakIndex < this.linearAdBreaks.length; ++breakIndex) {
      var br = this.linearAdBreaks[breakIndex];
      for (var _iterator2 = _createForOfIteratorHelperLoose(br.getAdverts()), _step2; !(_step2 = _iterator2()).done;) {
        var advert = _step2.value;
        if (advert.getMediaIdentifier() === mediaId && advert.isActive()) {
          match = advert;
          breakIndexFound = breakIndex;
          break;
        } else {
          advert.setInactive();
        }
      }
      if (match !== null) {
        break;
      }
    }

    // If this is not the first break then remove breaks prior to this one
    if (breakIndexFound > 0) {
      this.linearAdBreaks.splice(0, breakIndexFound);
    }
    return match;
  };
  _proto.getMetadataTimeout = function getMetadataTimeout(metadata) {
    if (metadata && metadata.getTypeWithinSegment() === _TimedMetadata.TypeWithinSegment.END) {
      return this.interSegmentTimeout;
    } else {
      return Math.max(this.targetDuration + 1000 >> 1, _Constant.Constant.MIN_INTRASEGMENT_TIMEOUT);
    }
  };
  _proto.getPlaybackMode = function getPlaybackMode() {
    return _Session2.PlaybackMode.LIVE;
  };
  _proto.handleMetaDataInSequence = function handleMetaDataInSequence(advert, metadata) {
    var currentAdvert = this.getCurrentAdvert();
    if (metadata.isFirstInSequence()) {
      // Start of an advert.  Start a break if required and notify clients
      this.onAdvertStart(advert, metadata.getPlayhead());
    } else if (metadata.isLastInSequence()) {
      // The order is important because HasAdvertExpired() returns false if currentAdvert is invalid
      if (currentAdvert && (!currentAdvert.isFiller() || this.hasAdvertExpired(currentAdvert, metadata))) {
        this.onAdvertEnd(AdvertStatus.PLAYED_OUT);
      }
    } else if (currentAdvert) {
      if (metadata.isLastInSegment() && (currentAdvert.isFiller() || currentAdvert.isTruncated()) && this.hasAdvertExpired(currentAdvert, metadata)) {
        // End of a filler segment or truncated advert
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Filler expired or truncated advert completed.  Ending advert and ad break");
        this.onAdvertEnd(AdvertStatus.PLAYED_OUT);
      } else {
        // Middle of an advert
        var delta = Math.max(metadata.getPlayhead() - currentAdvert.getStart(), 0);
        this.signalTimelineTrackingEvents(delta);
      }
    } else {
      // Start an ad break anyway, even if the advert is not known
      this.onAdvertBreakStart(advert);
    }
  };
  _proto.handleMetaDataOutOfSequence = function handleMetaDataOutOfSequence(advert, metadata) {
    var currentAdvert = this.getCurrentAdvert();
    if (!currentAdvert) {
      if (metadata.isFirstInSequence()) {
        // Not in an advert and TimedMetadata is the first ID3 tag of an advert
        this.onAdvertStart(advert, metadata.getPlayhead());
      } else {
        // In case an out-of-sequence tag is received and there is no valid advert.
        // This is the only place the Session should schedule an adbreak watchdog timer
        // when it may not be in an adbreak.
        this.scheduleAdvertBreakEnd(this.interSegmentTimeout);
      }
    } else if (currentAdvert.getMediaIdentifier() !== advert.getMediaIdentifier()) {
      // In advert (and therefore break) and Yospace ids differ
      this.onAdvertEnd(AdvertStatus.NOT_PLAYED_OUT);
      if (metadata.isFirstInSequence()) {
        // Start of the next advert so schedule
        this.onAdvertStart(advert, metadata.getPlayhead());
      } else if (metadata.isLastInSequence() || (advert.isFiller() || advert.isTruncated()) && metadata.isLastInSegment() && this.hasAdvertExpired(advert, metadata)) {
        advert.setInactive();
        if (!this.getCurrentAdBreak().isActive()) {
          this.onAdvertBreakEnd();
        }
      }
    }
  };
  _proto.hasAdvertExpired = function hasAdvertExpired(advert, metadata) {
    var ist = this.interSegmentTimeout;
    var dur = metadata.getPlayhead() - advert.getStart() + ist;
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "(SessionLive.hasAdvertExpired): Ad duration = " + advert.getDuration() + ", elapsed = " + advert.getDuration());
    return dur >= advert.getDuration();
  };
  _proto.initialiseFromSession = function initialiseFromSession(url) {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _YoLog.YoLog.trace("sdk init");
      if (!(0, _HttpUtils.getUrl)(url)) {
        _this2.completeWithStatus(_Session2.SessionState.FAILED, _Session2.MALFORMED_URL);
        reject(_this2);
        return;
      }
      _HttpConnection.HttpConnection.get(url, {
        method: "GET"
      }, _this2.sessionProperties.getRequestTimeout(), _this2.sessionProperties.getCustomHttpHeaders()).then(function (response) {
        if (response.ok) {
          var contentType = response.headers.get("content-type");
          if (contentType && contentType.toLowerCase().includes("application/json")) {
            if (_this2.handleFallbackUrl(response.body)) {
              resolve(_this2);
            } else {
              reject(_this2);
            }
          } else {
            var playerUrl = response.url ? response.url : url;
            _this2.parseManifestResponse(response.body, playerUrl);
            if (_this2.getSessionState() === _Session2.SessionState.INITIALISED) {
              _this2.initialisePoller();
            }
            resolve(_this2);
          }
        } else {
          if (response.timeout) {
            _YoLog.YoLog.e("Primary Url request failed: " + url + ", reason: timeout");
            _this2.completeWithStatus(_Session2.SessionState.FAILED, _Session2.CONNECTION_TIMEOUT);
          } else {
            _YoLog.YoLog.e("Primary Url request failed: " + url + ", status: " + response.status + ", error: " + response.statusText);
            _this2.completeWithStatus(_Session2.SessionState.FAILED, response.status);
          }
          reject(_this2);
        }
      });
    });
  };
  _proto.initialisePoller = function initialisePoller() {
    var _this3 = this;
    if (!this.getAnalyticsUrl() || this.getSessionState() !== _Session2.SessionState.INITIALISED) {
      return;
    }
    this.analyticPoller = new _UrlPoller.UrlPoller(this.getAnalyticsUrl(), this.getSessionProperties().getRequestTimeout(), function (response, retry) {
      if (response.status === 400) {
        _this3.onSessionError(_Session2.SessionErrorCode.TIMEOUT);
      } else if (response.ok) {
        _this3.targetDuration = retry;
        _this3.parseAnalyticPayload(response.body);
      }
    });
  };
  _proto.isMetadataInSequence = function isMetadataInSequence(current, next) {
    if (this.pendingTimedMetadata) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Pending metadata");
      return false;
    }
    return next.isInSequence(current);
  };
  _proto.onAdvertBreakEnd = function onAdvertBreakEnd() {
    if (!this.inAdBreak) {
      return;
    }
    var adbreak = this.getCurrentAdBreak();
    if (adbreak) {
      var report = adbreak.getTrackingReport("breakEnd", true);
      this.getReportsManager().fireBeacon(report, new _ReportsManager.ReportingParams(this.getPlayhead()));
    }
    this.inAdBreak = false;
    _YoLog.YoLog.trace("adbreakEnd");
    this.getReportsManager().raiseAdBreakCallback("end", null, this);

    // remove ad break from array if necessary
    if (this.linearAdBreaks.length > 0) {
      this.linearAdBreaks.splice(0, 1);
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Removed AdBreak.  Remaining: " + this.linearAdBreaks.length);
    }

    // reset data
    this.pendingTimedMetadata = null;
    this.historicalTimedMetadata = [];
    this.setCurrentAdvert(null);
    this.setCurrentAdBreak(null);
  };
  _proto.onAdvertBreakStart = function onAdvertBreakStart(advert) {
    if (this.inAdBreak) {
      return;
    }
    this.inAdBreak = true;
    var adBreak = this.getAdBreakForAdvert(advert);
    this.setCurrentAdBreak(adBreak);
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "AdBreak count: " + this.linearAdBreaks.length);
    _YoLog.YoLog.trace("adbreakStart");
    this.getReportsManager().raiseAdBreakCallback("start", adBreak, this);
    if (adBreak) {
      var report = adBreak.getTrackingReport("breakStart", !this.reportsManager.reportsSuppressed());
      this.getReportsManager().fireBeacon(report, new _ReportsManager.ReportingParams(this.getPlayhead()));
    }
  };
  _proto.onAdvertEnd = function onAdvertEnd(advertStatus) {
    if (!this.getCurrentAdvert()) {
      return;
    }

    // SDK-505: Cancel the advert watchdog if a new ad is not starting
    if (advertStatus !== AdvertStatus.NEW_ADVERT_STARTING) {
      this.cancelScheduleWatchdog();
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "onAdvertEnd(): new ad starting, not firing adbreak watchdog timer");
    }
    if (advertStatus === AdvertStatus.PLAYED_OUT) {
      this.signalTimelineTrackingEvents(this.getCurrentAdvert().getDuration());
    } else {
      this.getCurrentAdvert().clearTrackingSchedule();
    }
    this.getCurrentAdvert().setInactive();

    // Notify listeners
    _YoLog.YoLog.trace("advertEnd");
    this.getReportsManager().raiseAdvertCallback("end", null, this);
    this.setCurrentAdvert(null);

    // If the current ad break is played out then signal onAdvertBreakEnd.  Otherwise, schedule it to signal when the belt and
    // braces timer expires
    if (!this.getCurrentAdBreak().isActive()) {
      this.onAdvertBreakEnd();
    } else {
      // SDK-535: do this only if a new ad is not starting
      if (advertStatus !== AdvertStatus.NEW_ADVERT_STARTING) {
        this.scheduleAdvertBreakEnd(this.interSegmentTimeout);
      }
    }
  };
  _proto.onAdvertStart = function onAdvertStart(advert, timestamp) {
    advert.setStart(timestamp);

    // end the current ad if there is one
    this.onAdvertEnd(AdvertStatus.NEW_ADVERT_STARTING);

    // If not in a break, start one
    this.onAdvertBreakStart(advert);

    // Update the current break in case the VAST wasn't available at the point the first ID3 appeared
    this.setCurrentAdBreak(this.getAdBreakForAdvert(advert));
    if (!this.getCurrentAdBreak()) {
      _YoLog.YoLog.e("*** AdBreak is null ***");
      return;
    }
    this.setCurrentAdvert(advert);
    _Session.prototype.onAdvertStart.call(this, advert);
    if (this.reportsManager.reportsSuppressed()) {
      // clear the advert tracking map: do not fire beacons for partial adverts
      this.getCurrentAdvert().clearTrackingSchedule();
    }
    _YoLog.YoLog.trace("advertStart");
    this.getReportsManager().raiseAdvertCallback("start", advert, this);

    // Fire impressions
    this.fireImpressionReport();

    // Signal any tracking events
    this.signalTimelineTrackingEvents(_Constant.Constant.ADVERT_START_TIMESLOT);
  };
  _proto.parseAnalyticPayload = function parseAnalyticPayload(data) {
    var _this4 = this;
    return _Parser.Parser.parse(data, this).then(function (vmap) {
      if (!vmap) {
        return null;
      }
      if (_this4.getLastAnalyticUpdate() && vmap.isEqualTo(_this4.getLastAnalyticUpdate())) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Content unchanged.  Analytic update not delivered");
        return vmap;
      }
      var earlyReturn = vmap.getEarlyReturn();
      if (earlyReturn && earlyReturn !== -1) {
        _this4.adjustForEarlyReturn(earlyReturn);
      }
      _this4.setLastAnalyticUpdate(vmap);
      if (!vmap.hasAdBreaks()) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "No ad breaks in payload");
        if (!_this4.playing) {
          // Initial poll after playback ready
          _YoLog.YoLog.trace("sdk analytics 0 0 0");
          _this4.reportsManager.raiseAnalyticUpdateCallback(_this4);
        }
        return vmap;
      }
      _YoLog.YoLog.trace("sdk analytics: " + vmap.getLinearAdBreaks().length + " " + vmap.getNonLinearAdBreaks().length + " " + vmap.getDisplayAdBreaks().length);
      var notify = false;
      for (var _iterator3 = _createForOfIteratorHelperLoose(vmap.getLinearAdBreaks()), _step3; !(_step3 = _iterator3()).done;) {
        var adbreak = _step3.value;
        if (adbreak.getAdverts().length === 0) {
          // No adverts: just fire the ad break events (missed opportunity) then discard
          var params = new _ReportsManager.ReportingParams(_this4.getPlayhead());
          _this4.getReportsManager().fireBeacon(adbreak.getTrackingReport("breakStart", true), params);
          _this4.getReportsManager().fireBeacon(adbreak.getTrackingReport("breakEnd", true), params);
        } else {
          _this4.linearAdBreaks.push(adbreak);
          notify = true;
        }
      }
      for (var _iterator4 = _createForOfIteratorHelperLoose(vmap.getNonLinearAdBreaks()), _step4; !(_step4 = _iterator4()).done;) {
        var _adbreak = _step4.value;
        _this4.nonLinearAdBreaks.push(_adbreak);
        notify = true;
      }
      for (var _iterator5 = _createForOfIteratorHelperLoose(vmap.getDisplayAdBreaks()), _step5; !(_step5 = _iterator5()).done;) {
        var _adbreak2 = _step5.value;
        _this4.displayAdBreaks.push(_adbreak2);
        notify = true;
      }

      // SDK-371 - send onAnalyticUpdate before handling pending metadata
      // SDK-1190 - don't raise analytic update if pending metadata exists
      if (notify && !_this4.pendingTimedMetadata) {
        _this4.getReportsManager().raiseAnalyticUpdateCallback(_this4);
      }
      if (_this4.pendingTimedMetadata) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Process pending metadata: " + _this4.pendingTimedMetadata);
        var pending = _this4.pendingTimedMetadata;
        _this4.pendingTimedMetadata = null;
        _this4.onTimedMetadata(pending);
      }

      // Fire beacons for any historical adverts
      _this4.processHistoricalData();
      return vmap;
    })["catch"](function (err) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_POLLING, "Analytic Poll completed with unreadable data: " + err);
    });
  };
  _proto.onPlaybackContinue = function onPlaybackContinue() {
    if (this.isPlaybackBuffering()) {
      if (this.getCurrentAdvert()) {
        this.scheduleAdvertEnd();
      } else {
        // Don't schedule a watchdog timer if the session is not in an ad break
        if (this.getCurrentAdBreak()) {
          this.scheduleAdvertBreakEnd(this.interSegmentTimeout);
        }
      }
    }
    _Session.prototype.onPlaybackContinue.call(this);
  };
  _proto.onPlaybackPause = function onPlaybackPause() {
    _Session.prototype.onPlaybackPause.call(this);

    // Prevent premature firing of watchdog.  Will be restarted when playback starts again
    this.cancelScheduleWatchdog();
  };
  _proto.onPlaybackReady = function onPlaybackReady() {
    // Handles any error messages
    _Session.prototype.onPlaybackReady.call(this);
    if (this.getSessionState() === _Session2.SessionState.INITIALISED && this.playing !== true) {
      if (this.analyticPoller) {
        this.analyticPoller.poll(true);
      }
    }
  };
  _proto.onPlaybackResume = function onPlaybackResume() {
    if (this.isNotPlaying() && !this.isPlaybackBuffering()) {
      if (this.getCurrentAdvert()) {
        this.scheduleAdvertEnd(null);
      } else {
        // Don't schedule a watchdog timer if the session is not in an ad break
        if (this.getCurrentAdBreak()) {
          this.scheduleAdvertBreakEnd(this.interSegmentTimeout);
        }
      }
    }
    _Session.prototype.onPlaybackResume.call(this);
  };
  _proto.onPlaybackStall = function onPlaybackStall() {
    _Session.prototype.onPlaybackStall.call(this);

    // Prevent pramture firing of watchdog.  Will be restarted when buffering ends
    this.cancelScheduleWatchdog();
  };
  _proto.onPlaybackStart = function onPlaybackStart(playhead) {
    if (!this.isNotPlaying()) {
      _YoLog.YoLog.w("Reporting START when start has already been reported");
    } else if (this.getSessionState() !== _Session2.SessionState.INITIALISED) {
      _YoLog.YoLog.w("Reporting START when session has not been initialised");
    } else {
      _Session.prototype.onPlaybackStart.call(this, playhead);
      this.analyticPoller.start();
    }
  };
  _proto.onTimedMetadata = function onTimedMetadata(metadata) {
    _YoLog.YoLog.trace("timedmetadata " + metadata.getTypeWithinSegment().key + metadata.getSegmentNumber() + ":" + metadata.getSegmentCount() + " " + metadata.getPlayhead());
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Received metadata: " + metadata + ", timestamp: " + metadata.getTimestamp());
    if (this.isPlaybackBuffering()) {
      _YoLog.YoLog.w("Playback buffering - should not be receiving timed metadata");
      return;
    }
    if (this.isNotPlaying()) {
      _YoLog.YoLog.w("Playback not playing - should not be receiving timed metadata");
      return;
    }

    // Reschedule the advert end watchdogs
    this.scheduleAdvertEnd(metadata);
    if (metadata.isDuplicate(this.lastTimedMetadata) || metadata.isDuplicate(this.pendingTimedMetadata)) {
      // This can happen as a result of a level switch and is therefore not a warning
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Duplicate metadata: " + metadata);
      return;
    }

    // Find the relevant Advert
    var yospaceId = metadata.getMediaId();
    var advert = this.getFirstAdvertRemovingAllPrevious(yospaceId);
    if (!advert) {
      // Unknown advert
      if (metadata.isFirstInSequence()) {
        // This is the first TimedMetadata for the Advert.  Store it in case VAST is received
        // later during playback of the ad.
        // Note that the tag could be from filler, in which case (re)start the ad break end timer
        // to make sure it fires after the filler is finished.
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "FIRST pending metadata for advert " + yospaceId);
        this.pendingTimedMetadata = metadata;
        this.lastTimedMetadata = null;

        // Make a poll request to see whether VMAP can now be obtained
        if (this.analyticPoller) {
          this.analyticPoller.poll();
        }
      } else if (metadata.isLastInSequence() && this.getSessionProperties().getFireHistoricalBeacons() && this.pendingTimedMetadata) {
        // This is the last TimedMetadata for the Advert: as long as the first metadata tag is received,
        // move it to the array of historicals so that if VAST subsequently arrives during this ad break
        // the Session can fire beacons on it.
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "LAST pending metadata for advert: " + yospaceId + " .  Moving to historical list");
        this.historicalTimedMetadata.push(this.pendingTimedMetadata);
        this.pendingTimedMetadata = null;
      }

      // Start an advert break if one is not active
      this.onAdvertBreakStart(null);
      return;
    }

    // A valid Advert is known at this point.  Check whether the TimedMetadata is in the expected sequence
    if (this.isMetadataInSequence(this.lastTimedMetadata, metadata)) {
      this.lastTimedMetadata = metadata;
      this.handleMetaDataInSequence(advert, metadata);
      return;
    }
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Metadata out of sequence");
    this.pendingTimedMetadata = null;
    this.lastTimedMetadata = metadata;
    this.handleMetaDataOutOfSequence(advert, metadata);
  };
  _proto.parseManifestResponse = function parseManifestResponse(response, url) {
    var playlist = response;
    var payload = null;
    if (_HlsManifestParser.HlsManifestParser.isHlsManifest(playlist)) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Processing HLS master playlist: " + url);
      payload = _HlsManifestParser.HlsManifestParser.parse(url, playlist);
    } else {
      // DASH
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Processing DASH manifest: " + url);
      payload = _DashManifestParser.DashManifestParser.parse(playlist);
    }
    if (!payload) {
      this.setPlaybackUrl(null);
      _YoLog.YoLog.w("Playlist/manifest processing unsuccesful");
      this.completeWithStatus(_Session2.SessionState.NO_ANALYTICS, _Session2.UNKNOWN_FORMAT);
    } else if ((0, _StringUtils.isNullOrEmpty)(payload.getAnalyticUrl())) {
      this.setPlaybackUrl(url);
      _YoLog.YoLog.e("Analytics URL not found in manifest payload");
      _YoLog.YoLog.w("Playlist/manifest processing unsuccesful");
      this.completeWithStatus(_Session2.SessionState.NO_ANALYTICS, 0);
    } else if (!(0, _HttpUtils.getUrl)(payload.getAnalyticUrl())) {
      this.setPlaybackUrl(url);
      _YoLog.YoLog.e("Malformed analytics URL in manifest payload");
      _YoLog.YoLog.w("Playlist/manifest processing unsuccessful");
      this.completeWithStatus(_Session2.SessionState.NO_ANALYTICS, _Session2.MALFORMED_URL);
    } else {
      // Store the properties
      this.setPlaylistProperties(payload);
      this.interSegmentTimeout = payload.getIntersegmentTimeout();
      this.completeWithStatus(_Session2.SessionState.INITIALISED, 0);
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Successful.  URL: " + this.getPlaybackUrl());
    }
  };
  _proto.processHistoricalData = function processHistoricalData() {
    var ab = this.getCurrentAdBreak();
    if (ab) {
      for (var _iterator6 = _createForOfIteratorHelperLoose(this.historicalTimedMetadata), _step6; !(_step6 = _iterator6()).done;) {
        var metadata = _step6.value;
        var yospaceId = metadata.getMediaId();
        var advert = ab.getAdvertFromIdentifier(yospaceId);
        if (advert) {
          _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_REPORTS, "Firing beacon for historical advert: " + yospaceId);
          var params = new _ReportsManager.ReportingParams(this.getPlayhead(), advert.getStart(), advert.getLinearCreative().getAssetUri(), advert.getMacroSubstitutions());
          var keys = [];
          for (var _iterator7 = _createForOfIteratorHelperLoose(advert.getTrackingSchedule()), _step7; !(_step7 = _iterator7()).done;) {
            var _step7$value = _step7.value,
              key = _step7$value[0],
              value = _step7$value[1];
            keys.push(key);
            var report = advert.getTrackingReportLinear(value);
            if (report) {
              _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_REPORTS, "Firing beacon(s) for event: " + key);
              this.getReportsManager().fireBeacon(report, params);
            }
          }
          this.removeKeysFromTrackingSchedule(keys);
        }
      }
    }
    this.historicalTimedMetadata = [];
  };
  _proto.scheduleAdvertBreakEnd = function scheduleAdvertBreakEnd(after) {
    this.cancelScheduleWatchdog();
    this.advertEndWatchdog = setTimeout(this.metadataWatchdogEndBreak.bind(this), after);
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Scheduled adbreak end watchdog timer: " + after + "ms");
  };
  _proto.scheduleAdvertEnd = function scheduleAdvertEnd(metadata) {
    this.cancelScheduleWatchdog();
    var timeout = this.getMetadataTimeout(metadata);
    this.advertEndWatchdog = setTimeout(this.metadataWatchdog.bind(this), timeout);
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "Scheduled advert end watchdog timer: " + timeout + "ms");
  };
  _proto.setTargetDuration = function setTargetDuration(duration) {
    this.targetDuration = duration;
  };
  _proto.shutdown = function shutdown() {
    _Session.prototype.shutdown.call(this);
    this.cancelScheduleWatchdog();

    // Due to JS "Run-to-completion", we don't expect any concurrency issues when shutting down and setting
    // the poller to null
    if (this.analyticPoller) {
      this.analyticPoller.shutdown();
      this.analyticPoller = null;
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Analytic poller cancelled");
    }
  };
  _proto.setPlaylistProperties = function setPlaylistProperties(payload) {
    this.setIdentifier(payload.getSessionIdentifier());
    this.setAnalyticsUrl(payload.getAnalyticUrl());
    this.setPlaybackUrl(payload.getLocation());
  };
  _proto.metadataWatchdog = function metadataWatchdog() {
    _YoLog.YoLog.w("Watchdog timer expired before metadata was received");
    if (this.pendingTimedMetadata) {
      this.onAdvertBreakEnd();
    } else {
      this.onAdvertEnd(AdvertStatus.NOT_PLAYED_OUT);
    }
  };
  _proto.metadataWatchdogEndBreak = function metadataWatchdogEndBreak() {
    _YoLog.YoLog.w("Watchdog timer expired before metadata was received");
    this.onAdvertBreakEnd();
  };
  return SessionLive;
}(_Session2.Session);
exports.SessionLive = SessionLive;